// components/templates/sections/FOOTER_COFFEE.tsx
import React from "react";
import { useDesign } from "@/context/DesignContext";

type FooterProps = { brand?: string; links?: string[] | string; design?: any };

export default function FOOTER_COFFEE({ brand = "Vertrin", links = [], design: propDesign }: FooterProps) {
  const contextDesign = useDesign();
  const design = propDesign || contextDesign;
  const linksArray = Array.isArray(links) ? links : [];

  const bgColor = design?.colors?.background || "#0C0500";
  const textColor = design?.colors?.text || "#F5E6D3";
  const textLightColor = design?.colors?.textLight || "#BFA76A";
  const borderColor = design?.colors?.border || "#3D2A1A";

  return (
    <footer className="py-12 border-t" style={{ background: bgColor, borderColor: `${borderColor}4D` }}>
      <div className="max-w-7xl mx-auto px-8 flex flex-col md:flex-row justify-between items-center gap-6">
        <div className="font-display tracking-widest uppercase text-sm" style={{ color: textColor }}>{brand}</div>
        <div className="flex gap-8">
          {linksArray.map((link) => (
            <a key={link} href="#" className="font-mono-custom text-xs transition-colors"
               style={{ color: `${textLightColor}80` }}
               onMouseEnter={(e) => e.currentTarget.style.color = textLightColor}
               onMouseLeave={(e) => e.currentTarget.style.color = `${textLightColor}80`}>
              {link}
            </a>
          ))}
        </div>
        <div className="font-mono-custom text-xs" style={{ color: `${borderColor}99` }}>© {new Date().getFullYear()} — All rights reserved</div>
      </div>
    </footer>
  );
}